import { createApiClientForEndpoint } from "../lib/apiClient";

const api = createApiClientForEndpoint("notifications");

export const fetchAlarmNotificationStats = async ({ queryKey }) => {
  const [, alarmId] = queryKey;
  if (!alarmId) return null;
  const response = await api.get(`/alarm/${alarmId}/stats`);
  return response.data ?? null;
};

export const fetchAlarmNotificationDeliveries = async ({ queryKey }) => {
  const [, alarmId] = queryKey;
  if (!alarmId) return [];
  const response = await api.get(`/alarm/${alarmId}/deliveries`);
  return Array.isArray(response.data) ? response.data : [];
};
